<div class="flex-column h-100">
  <div class="configuration-wizard-header flex-column">
    <h5
      class="odx-title-5"
      i18n="@@gasWarningCenterConfiguration.selectGasWarningCenter.header"
      data-testid="gasWarningCenterConfiguration.selectGasWarningCenter.header"
    >
      Gaswarnzentrale auswählen
    </h5>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    @if (filteredGasWarningCenters$ | async; as gasWarningCenters) {
      @if (gasWarningCenters.length > 0) {
        <form [formGroup]="gasWarningCenterForm" class="h-100">
          <odx-radio-group formControlName="selectedGasWarningCenter" required="true" class="h-100">
            <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
              @for (gasWarningCenter of gasWarningCenters; track gasWarningCenter) {
                <app-gas-warning-center-card
                  class="overflow-hidden"
                  [gasWarningCenterData]="gasWarningCenter"
                  selectionMode="single"
                  [showCosts]="project.showCostFlag"
                  [quantity]="gasWarningCenterForm.value.selectedGasWarningCenter?.id === gasWarningCenter.id ? 1 : 0"
                  [preselectedQuantity]="preselected?.id === gasWarningCenter.id ? 1 : null"
                  [type]="gasWarningCenterType!"
                  (click)="select(gasWarningCenter, 1)"
                  (quantityChanged$)="select(gasWarningCenter, $event)"
                >
                </app-gas-warning-center-card>
              }
            </div>
          </odx-radio-group>
        </form>
      } @else {
        <app-refresh-products-hint
          dataType="Gaswarnzentralen"
          i18n-dataType="@@global.gasWarningCenters"
        ></app-refresh-products-hint>
      }
    }
  </odx-content-box>
</div>
